// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"9712e57e","475":"722af492"}[chunkId] + ".chunk.js";
};